import { ClubMembershipRequestStatus } from '@shared/enums/domain.enum';
import { Role } from '@shared/enums/role.enum';
import { Check, Clock, Shield, X } from 'lucide-react';

export function RoleBadge({ role, isClubAdmin }: { role: Role; isClubAdmin: boolean }) {
  if (isClubAdmin || role === Role.CLUB_ADMIN) {
    return (
      <span className='inline-flex items-center gap-1 rounded-full bg-purple-100 px-2.5 py-0.5 text-xs font-semibold text-purple-700'>
        <Shield className='h-3 w-3' /> Admin
      </span>
    );
  }
  return (
    <span className='inline-flex items-center rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700'>
      Membre
    </span>
  );
}

export function StatusBadge({ disabled }: { disabled: boolean }) {
  if (disabled) {
    return (
      <span className='inline-flex items-center gap-1 rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-semibold text-amber-700'>
        <span className='h-1.5 w-1.5 rounded-full bg-amber-500' />
        Inactif
      </span>
    );
  }
  return (
    <span className='inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2.5 py-0.5 text-emerald-700 text-xs font-semibold'>
      <span className='h-1.5 w-1.5 rounded-full bg-emerald-500' />
      Actif
    </span>
  );
}

const REQ_STATUS_CONFIG: Record<
  ClubMembershipRequestStatus,
  { label: string; bg: string; text: string; icon: React.ReactNode }
> = {
  [ClubMembershipRequestStatus.PENDING]: {
    label: 'En attente',
    bg: 'bg-amber-100',
    text: 'text-amber-700',
    icon: <Clock className='h-3 w-3' />,
  },
  [ClubMembershipRequestStatus.ACCEPTED]: {
    label: 'Accepté',
    bg: 'bg-emerald-100',
    text: 'text-emerald-700',
    icon: <Check className='h-3 w-3' />,
  },
  [ClubMembershipRequestStatus.REJECTED]: {
    label: 'Refusé',
    bg: 'bg-red-100',
    text: 'text-red-700',
    icon: <X className='h-3 w-3' />,
  },
};

export function RequestStatusBadge({ status }: { status: ClubMembershipRequestStatus }) {
  const cfg = REQ_STATUS_CONFIG[status];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ${cfg.bg} ${cfg.text}`}
    >
      {cfg.icon}
      {cfg.label}
    </span>
  );
}
